import http from 'lc-http';

export const SET_PREVIOUS_ROUTE = 'SET_PREVIOUS_ROUTE';
export const GET_APPLICATION = 'GET_APPLICATION';
export const GET_APPLICATION_COMPLETE = 'GET_APPLICATION_COMPLETE';
export const UPDATE_PROGRESS_BAR = 'UPDATE_PROGRESS_BAR';

export const setPreviousRoute = (previousRoute) => ({
  type: SET_PREVIOUS_ROUTE,
  previousRoute
});

export const applicationInReview = (location) =>
  location.search && /status\=review/.test(location.search);

const getApp = () => {
  return http.get('/patientsolutions/enroll/application');
};

export const getApplication = (getFn = getApp) => {
  return (dispatch) => {
    dispatch({ type: GET_APPLICATION });
    return getFn()
      .then(({ data }) => {
        dispatch({
          type: GET_APPLICATION_COMPLETE,
          payload: { ...data }
        });
      })
      .catch(() => {
        dispatch({
          type: GET_APPLICATION,
          error: 'An error has occurred in retrieving the application'
        });
      });
  };
};

